import gql from 'graphql-tag'
import {
	priceLevels as priceLevelsFragment,
	cashFlow as cashFlowFragment,
	kitchen as kitchenFragment,
	printerLocations as printerLocationsFragment,
	order as orderFragment,
	exportFragment
} from './fragments'


export const priceLevels = gql`
	mutation updateAppConfig($fields: AppConfigInput) {
		cashAssist {
			updateAppConfig(fields: $fields) {
				...priceLevels
			}
		}
	}
	${priceLevelsFragment}
`

export const cashFlow = gql`
	mutation updateAppConfig($fields: AppConfigInput) {
		cashAssist {
			updateAppConfig(fields: $fields) {
				...cashFlow
			}
		}
	}
	${cashFlowFragment}
`

export const discountNames = gql`
	mutation updateAppConfigAdditional($fields: AppConfigAdditionalInput) {
		cashAssist {
			updateAppConfigAdditional(fields: $fields) {
				discountGroupNames
				defaultDiscountMobileCard
			}
		}
	}
`

export const tara = gql`
	mutation updateAppConfig($fields: AppConfigInput) {
		cashAssist {
			updateAppConfig(fields: $fields) {
				taraName
			}
		}
	}
`

export const kitchen = gql`
	mutation updateAppConfig($fields: AppConfigInput) {
		cashAssist {
			updateAppConfig(fields: $fields) {
				...kitchen
			}
		}
	}
	${kitchenFragment}
`

export const printerLocations = gql`
	mutation updateAppConfig($fields: AppConfigInput) {
		cashAssist {
			updateAppConfig(fields: $fields) {
				...printerLocations
			}
		}
	}
	${printerLocationsFragment}
`

export const order = gql`
	mutation updateAppConfig($fields: AppConfigInput) {
		cashAssist {
			updateAppConfig(fields: $fields) {
				...order
			}
		}
	}
	${orderFragment}
`

export const updateAppConfigAdditional = gql`
	mutation updateAppConfig($fields: AppConfigInput) {
		cashAssist {
			updateAppConfig(fields: $fields) {
				...exportFragment
			}
		}
	}
	${exportFragment}
`

export default {
	priceLevels,
	cashFlow,
	discountNames,
	tara,
	kitchen,
	printerLocations,
	order,
	updateAppConfigAdditional
}
